import { Container, Grid2, TextField, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React, { forwardRef, useImperativeHandle } from "react";
import AddContactList from "./common/AddContactList";

const OUTSIDE_SPACING = 5;
const INSIDE_SPACING = 3;

const CompanyFormCore = (props, ref) => {
    const { disabled, handleSubmit, values, handleChange, setFieldValue, errors, touched, handleBlur } = props;

    useImperativeHandle(ref, () => ({
        submit: (e) => handleSubmit(e),
    }));

    function handleChangePhone(phone, field) {
        setFieldValue(field, phone);
    }

    function getCommonProps(name) {
        return {
            name: name,
            onBlur: handleBlur,
            value: values[name],
            onChange: handleChange,
            error: touched[name] && errors[name] ? errors[name] : null,
            helperText: touched[name] && errors[name] ? errors[name] : null,
            variant: "outlined",
            fullWidth: true,
        };
    }

    return (
        (<Container>
            <form style={{ display: "block" }} onSubmit={handleSubmit}>
                <Grid2 container spacing={OUTSIDE_SPACING} size={12}>
                    {!disabled ? (
                        <Grid2 container spacing={INSIDE_SPACING} size={12}>
                            <Grid2 container size={12}>
                                <Typography>Name</Typography>
                            </Grid2>
                            <Grid2
                                size={{
                                    xs: 12,
                                    lg: 12
                                }}>
                                <TextField {...getCommonProps("label")} disabled={disabled} />
                            </Grid2>
                        </Grid2>
                    ) : null}
                    <Grid2 size={12}>
                        <AddContactList
                            disabled={disabled}
                            values={values}
                            setFieldValue={setFieldValue}
                            commonProps={getCommonProps}
                            onChangePhone={handleChangePhone}
                            errors={errors.addressList}
                            touched={touched.addressList}
                            xs={1}
                            xl={1}
                        />
                    </Grid2>
                </Grid2>
            </form>
        </Container>)
    );
};

const CompanyForm = forwardRef(CompanyFormCore);

CompanyFormCore.propTypes = {
    disabled: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired,
    handleBlur: PropTypes.func.isRequired,
};

export default CompanyForm;
